import { render, staticRenderFns } from "./NpaComments.vue?vue&type=template&id=15c9f70d&scoped=true&"
import script from "./NpaComments.vue?vue&type=script&lang=js&"
export * from "./NpaComments.vue?vue&type=script&lang=js&"
import style0 from "./NpaComments.vue?vue&type=style&index=0&id=15c9f70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9f70d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VCheckbox,VMenu,VOverlay,VProgressCircular,VTextarea})
